module.exports = __webpack_public_path__ + "img/1. LOGO PRINCIPAL_FUNDO TRANSPARENTE.11dd38c7.png";